import { useQuery } from "@helium10/re-core";
import { useCallback, useEffect } from "react";
import type { Params } from "react-router-dom";
import { generatePath } from "react-router-dom";

export const useLink = () => {
  const { accountId } = useQuery<{ accountId: string }>();

  const appendAccountId = useCallback(
    <S extends string>(url: string, params?: Params<S>): string =>
      generatePath(url, { accountId, ...params }),
    [accountId],
  );

  return {
    appendAccountId,
  };
};

export function NotMatch() {
  useEffect(() => {
    window.open(window.location.href, "_self");
  }, []);

  return null;
}
